<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">Toilet Report</h4>
    </div>
    <div class="col-sm-3"></div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <!-- <div class="row p-t-20"> 
					<div class="col-md-3">
                        <div class="form-group">
                            <label class="control-label">Select Date</label>
                            <input type="date" id="dateTime" name="dateTime" class="form-control">
                         </div>
                    </div>
                    <div style="margin-top: 30px;"  class="col-md-2">
                        <button type="button" class="btn btn-outline-info" (click)="ShowReport()">Submit</button>
                    </div>
                </div> -->
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                    class="table table-bordered table-striped table-hover text-center">
                        <thead >
                            <tr>
                                <th>Sr. No.</th>
                                <th>Zone</th>
                                <th>Ward</th>
                                <th>Toilet ID</th>
                                <th>MoHUA (GTL ID)</th>
                                <th>Toilet Name</th>
                                <th style="white-space: normal;">Address</th>
                                <th style="white-space: normal;">Landmark</th>
                                <!-- <th>Lattitude</th>
                                <th>Longitude</th> -->
                                <!-- <th>Toilet Type</th> -->
                                <th>Assign Device</th>
                                <!-- <th>Assign Device Date</th> -->
                                <th *ngIf="roleId==0">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr *ngFor="let tData of toiletRowdata; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{tData.zone_name}}</td>
                                <td>{{tData.ward_name}}</td>
                                <td style="white-space: normal;">{{tData.toilet_no}}</td>
                                <td style="white-space: normal;">{{tData.google_toilet_id}}</td>
                                <td style="white-space: normal;">{{tData.toilet_name}}</td>
                                <td style="white-space: normal;">{{tData.address}}</td>
                                <td style="white-space: normal;">{{tData.landmark}}</td>
                                <!-- <td>{{tData.lattitude}}</td>
                                <td>{{tData.longitude}}</td> -->
                                <!-- <td>{{tData.toilet_type}}</td> -->
                                <td>{{tData.device_id}}</td>
                                <!-- <td>{{tData.device_assignment_date | date:'dd-MM-yyyy'}}</td> -->
                                <!-- <td style="text-align: center;">
                                    <a (click)="EditToilet(tData.toilet_id)" style="color: dodgerblue">
                                        <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                    </a><span style="margin-left: 15px;"></span>
                                    <a (click)="DeleteToilet(tData.toilet_id)" style="color: red;">
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                    </a>
                                </td> -->
                                <td *ngIf="roleId==0" style="text-align: center;">
                                    <button (click)="UpdateLiveDeviceStatus(tData.device_id)" class="btn btn-primary btn-sm">Clean</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>